import React from "react";
import BlogArticle from "../Blog/BlogArticle";
import "./PostPreview.css";

const PostPreview = ({ post, onClose }) => {
  return (
    <div className="preview-overlay">
      <div className="preview-bar">
        <span>Önizleme — yayınlanınca sitede böyle görünecek</span>
        <button onClick={onClose}>Kapat</button>
      </div>
      <div className="preview-scroll">
        <BlogArticle post={post} />
      </div>
    </div>
  );
};

export default PostPreview;
